import { Box } from "@material-ui/core";
import { SparkLineChart } from "@mui/x-charts";
import { useStyles } from "./styles";
import { FC } from "react";

interface SparkLineChartTempProps {
  data: any;
  height: number;
}

export const SparkChartTemp: FC<SparkLineChartTempProps> = ({ data, height }) => {
  const classes = useStyles();
  return (
    <Box className={classes.chartBox}>
      <SparkLineChart
        data={data}
        area={true}
        height={height}
        colors={["#0038FF"]} // Vibrant blue line color
        margin={{ top: 10, bottom: 0, left: 0, right: 0 }}
        sx={{
          // Adjust the fill opacity to match the soft blue tint
          "& .MuiAreaElement-root": {
            fillOpacity: 0.15,
          },
          // Adjust stroke thickness
          "& .MuiLineElement-root": {
            strokeWidth: 3.5,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          },
        }}
      />
    </Box>
  );
};
